/**
 * 这个方法的意图是在触发一下几个 chunk 文件的加载
 * 所以以下几个文件虽然是空的，但也不能删除，这几个文件的唯一用处就是他们的 webpackChunkName
 */
export function loadChunks() {
    Promise.all([
        // @ts-ignore
        import(/* webpackChunkName: "player" */ './player').then()
            .catch((err) => {
                window.log.error(`[loadChunk-error]${err}`);
            }),
        // @ts-ignore
        import(/* webpackChunkName: "meetingroom" */ './meetingroom').then()
            .catch((err) => {
                window.log.error(`[loadChunk-error]${err}`);
            }),
        // @ts-ignore
        import(/* webpackChunkName: "lazyComponents" */ './lazyComponents').then()
            .catch((err) => {
                window.log.error(`[loadChunk-error]${err}`);
            }),
        // @ts-ignore
        import(/* webpackChunkName: "service" */ './service').then()
            .catch((err) => {
                window.log.error(`[loadChunk-error]${err}`);
            }),
        // @ts-ignore
        import(/* webpackChunkName: "busiModules" */ './busiModules').then()
            .catch((err) => {
                window.log.error(`[loadChunk-error]${err}`);
            }),
    ]).then(() => {
        // window.log.info('[loadChunk-info] loadChunksResult');
    })
        .catch((err) => {
            window.log.error(`[loadChunk-error]${err}`);
        });
}
